module.exports = __webpack_public_path__ + "img/OrgChartTemp1.1a5c9fdf.png";